import { render, staticRenderFns } from "./SiderBarltem.vue?vue&type=template&id=5ca90bc2&"
import script from "./SiderBarltem.vue?vue&type=script&lang=js&"
export * from "./SiderBarltem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports